import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import type { Article } from "@/mocks/articles";

interface LatestNewsProps {
  articles: Article[];
}

export default function LatestNews({ articles }: LatestNewsProps) {
  return (
    <section aria-label="最新资讯">
      <SectionHeading
        eyebrow="LATEST"
        icon="ri-flashlight-fill"
        title="最新资讯"
        description="按发布时间汇总的娱乐要闻，快速了解今天值得关注的内容。"
        actionTo="/category/news"
        actionLabel="查看全部"
      />
      <div className="flex flex-col gap-4">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}